var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrganizationIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#organization-icon-active_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.65 13.65v11.7h5.85v-11.7zM5.325 13a.325.325 0 0 0-.325.325V26h6.825c.18 0 .325-.145.325-.325v-12.35a.325.325 0 0 0-.325-.325z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.65 13.65v11.7h5.85v-11.7zm-.325-.65a.325.325 0 0 0-.325.325V26h6.825c.18 0 .325-.145.325-.325v-12.35a.325.325 0 0 0-.325-.325z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#152F4D",
    d: "M8.53 10h7.15v13H8.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.18 10.65v11.7h5.85v-11.7zM8.855 10a.325.325 0 0 0-.325.325V23h6.825c.18 0 .325-.145.325-.325v-12.35a.325.325 0 0 0-.325-.325z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00F2B6",
    fillRule: "evenodd",
    d: "M10.805 11.95a.325.325 0 0 0-.325.324v.65a.325.325 0 1 0 .65 0v-.65a.325.325 0 0 0-.325-.325Zm1.3 0a.325.325 0 0 0-.325.324v.65a.325.325 0 1 0 .65 0v-.65a.325.325 0 0 0-.325-.325Zm1.3 0a.325.325 0 0 0-.325.324v.65a.325.325 0 1 0 .65 0v-.65a.325.325 0 0 0-.325-.325Zm-2.6 2.6a.325.325 0 0 0-.325.326v.65a.325.325 0 1 0 .65 0v-.65a.325.325 0 0 0-.325-.325Zm1.3 0a.325.325 0 0 0-.325.326v.65a.325.325 0 1 0 .65 0v-.65a.325.325 0 0 0-.325-.325Zm1.3 0a.325.325 0 0 0-.325.326v.65a.325.325 0 1 0 .65 0v-.65a.325.325 0 0 0-.325-.325Z",
    clipRule: "evenodd"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    x: 2.5,
    y: 3.5,
    stroke: "#fff",
    rx: 9.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "organization-icon-active_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 2,
    y: 3,
    fill: "#fff",
    rx: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationIconActive);
export default __webpack_public_path__ + "static/media/organization-icon-active.0c8ad54f5cd7d246c2166eb88be3c484.svg";
export { ForwardRef as ReactComponent };